import { render, staticRenderFns } from "./TableOrganogram.vue?vue&type=template&id=7e5a244f&scoped=true&"
import script from "./TableOrganogram.vue?vue&type=script&lang=js&"
export * from "./TableOrganogram.vue?vue&type=script&lang=js&"
import style0 from "./TableOrganogram.vue?vue&type=style&index=0&id=7e5a244f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5a244f",
  null
  
)

export default component.exports